import { Grid } from '@mui/material';
import axios from 'axios'; // For making API requests
import { useSnackbar } from 'notistack';
import PropTypes from 'prop-types';
import MatterCard from './MatterCard';

MatterList.propTypes = {
  matters: PropTypes.array.isRequired,
  onDeleteMatter: PropTypes.func.isRequired,
  isAdmin: PropTypes.bool.isRequired,
  statusTooltips: PropTypes.object.isRequired,
  setMatters: PropTypes.func.isRequired,
  isDeletedView: PropTypes.bool,
  onRestoreMatter: PropTypes.func,
};

export default function MatterList({ matters, onDeleteMatter, isAdmin, statusTooltips, setMatters, isDeletedView, onRestoreMatter, ...other }) {
  const { enqueueSnackbar } = useSnackbar();
  
  const handleUpdateStatus = async (id, newStatus) => {
    try {
      const url = `/api/legal-matter/${id}/status`;
  
      console.log(`Making PUT request to: ${url}`);
  
      const response = await axios.put(url, { newStatus });
  
      if (response.status === 200) {
        console.log('Updating state with new status...');
  
        setMatters((prevMatters) => 
          prevMatters.map((matter) => 
            matter.id === id ? { ...matter, status: newStatus } : matter
          )
        );
  
        enqueueSnackbar('Status updated successfully', { variant: 'success' });
      } else {
        enqueueSnackbar('Failed to update status', { variant: 'error' });
      }
    } catch (error) {
      console.error('Error updating status:', error);
      enqueueSnackbar('Failed to update status', { variant: 'error' });
    }
  };
  
  
  return (
    <Grid container spacing={4} {...other} sx={{ display: 'flex', flexWrap: 'wrap' }}>
      {matters.map((matter) => (
        <Grid item xs={12} sm={6} md={4} lg={3} key={matter.id}>
          <MatterCard 
            matter={matter} 
            onDelete={onDeleteMatter} 
            onUpdateStatus={(id, newStatus) => handleUpdateStatus(id, newStatus)}
            isAdmin={isAdmin} 
            statusTooltips={statusTooltips}
            isDeletedView={isDeletedView}
            onRestore={onRestoreMatter}
          />
        </Grid>
      ))}
    </Grid>
  );
}
